import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-control',
  standalone: true,
  imports: [],
  templateUrl: './admin-control.component.html',
  styleUrl: './admin-control.component.scss',
})
export class AdminControlComponent {}
